export const handledApiErrors = ['otp-expired'];
